import { ValidationModalSubmitButton as ValidationModalSubmitButtonType } from '@/schemas/sceneDataSchema';
import { ComponentButton } from './ComponentButton';
import useAnalytics, { eventName } from '@/hooks/use-analytics';
import useModal from '@/hooks/use-modals';
import { useScopesValidity } from '@/hooks/use-entity-validity';
import { useValidationSync } from '@/hooks/use-validation-sync';
import { UseFormReturn } from 'react-hook-form';
import { reportError } from '@/services/error-reporting-service';
import type { MouseEvent } from 'react';

export const ValidationModalSubmitButton = ({
  component,
  form,
}: {
  component: ValidationModalSubmitButtonType;
  form?: UseFormReturn;
}) => {
  const { trackClick } = useAnalytics();
  const { getModal } = useModal();
  const scopesValidity = useScopesValidity(component.validation_scopes);
  const { syncValidationScopes } = useValidationSync(component.validation_scopes, form);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    trackClick(eventName(component.id), { button_type: component.type });

    if (scopesValidity === false) {
      event.preventDefault();
      void syncValidationScopes().catch((error) => {
        reportError({ error });
      });
      getModal(component.modal_id)?.open();
    }
  };

  return (
    <ComponentButton
      form={component.form_id}
      component={component}
      type='submit'
      onClick={handleClick}
    />
  );
};
